import { render, staticRenderFns } from "./RegionsOverviewView.vue?vue&type=template&id=e15df024"
import script from "./RegionsOverviewView.vue?vue&type=script&lang=js"
export * from "./RegionsOverviewView.vue?vue&type=script&lang=js"
import style0 from "./RegionsOverviewView.vue?vue&type=style&index=0&id=e15df024&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports